import React, { useMemo } from 'react';
import { ComplexStatusRoundingDirection, ComplexStatusState, ComplexStatus as ComplexStatusType } from 'src/constants/complexStatus';
import { useComplexStatus } from 'src/hooks/app/use-complex-status';
import { useContrastRatio } from 'src/hooks/useContrastRatio';
import { useStyles } from './styles';

interface IProps {
  complexStatus?: ComplexStatusType,
  state?: ComplexStatusState,
  roundingDirection?: ComplexStatusRoundingDirection,
}
export const ComplexStatus: React.FC<IProps> = ({
  complexStatus,
  state = ComplexStatusState.STABLE,
  roundingDirection = ComplexStatusRoundingDirection.LEFT,
}) => {
  const { getComplexStatusColor } = useComplexStatus(complexStatus);
  const { getColorByBgColor } = useContrastRatio();
  const styles = useStyles({ roundingDirection, textColor: getColorByBgColor(getComplexStatusColor || '') });
  const getWrapperStyle = useMemo(() => {
    switch (state) {
      case ComplexStatusState.DEFAULT: {
        return styles.complexStatusWrapperDefault;
      }
      case ComplexStatusState.HOVERED: {
        return styles.complexStatusWrapperHovered;
      }
      case ComplexStatusState.STABLE: {
        return styles.complexStatusWrapperStable;
      }
      default: return styles.complexStatusWrapperStable;
    }
  }, [state]);

  return (
    <div
      className={`${getWrapperStyle}`}
      style={{ backgroundColor: getComplexStatusColor }}
    >
      <span className="text">
        {([ComplexStatusState.HOVERED, ComplexStatusState.STABLE].includes(state)) ? complexStatus : ''}
      </span>
    </div>
  );
};
